import React from "react"
import { Controller, useFormContext } from "react-hook-form"

import Form from "src/components/Form"

import FormUpload from "./FormUpload"

const RegistrationSection = () => {
  const {
    control,
    register,
    watch,
    formState: { errors },
  } = useFormContext()

  const registrationDocument = watch("registration.documentUpload")
  const registrationDocumentAttached = registrationDocument?.length > 0
  const currentDate = new Date()
  const maxYear = currentDate.getFullYear() + 10

  return (
    <div className="grid grid-cols-2 gap-4">
      <section>
        <Form.Label htmlFor="registration-number">
          Registration Number
        </Form.Label>
        <Form.TextField
          id="registration-number"
          {...register("registration.number", {
            required:
              registrationDocumentAttached &&
              "Registration number is required if a registration documentation is attached",
            pattern: {
              value: /^[a-zA-Z\d\s]+$/,
              message: "Only letters, numbers, and spaces are supported",
            },
          })}
          hasErrors={Boolean(errors.registrationNumber)}
        />
        {errors.registration?.number && (
          <Form.Error>{errors.registration?.number.message}</Form.Error>
        )}
      </section>
      <section>
        <FormUpload
          id={"registration.documentUpload"}
          label="Registration Document Upload"
        />
      </section>
      <section>
        <Form.Label htmlFor="registration-expiration-date">
          Expiration Date
        </Form.Label>
        <Controller
          control={control}
          name="registration.expirationDate"
          rules={{
            required:
              registrationDocumentAttached &&
              "Expiration date is required if a registration documentation is attached",
          }}
          render={({ field: { onChange, value } }) => (
            <Form.DatePicker
              {...{ onChange, value }}
              id="registration-expiration-date"
              renderCustomHeader={(props) => (
                <Form.DatePicker.QuickNavHeader
                  {...props}
                  yearRangeStart={currentDate.getFullYear()}
                  yearRangeEnd={maxYear}
                />
              )}
              minDate={currentDate}
              maxDate={new Date(maxYear, 11, 31)}
              placeholderText="MM/DD/YY"
            />
          )}
        />
        {errors.registration?.expirationDate && (
          <Form.Error>{errors.registration?.expirationDate.message}</Form.Error>
        )}
      </section>
    </div>
  )
}

export default RegistrationSection
